module.exports = __webpack_public_path__ + "static/media/SDFSA_8-634w.63526da8.jpg";